(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define("footerbundle", ["React"], factory);
	else if(typeof exports === 'object')
		exports["footerbundle"] = factory(require("React"));
	else
		root["footerbundle"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__1024__) => {
return 